var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMostViewedRisk = function SvgMostViewedRisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0107 10.8478C22.1474 2.22152 7.88306 0.333496 7.88306 0.333496C7.88306 0.333496 14.4651 7.521 6.05364 13.2046C0.734625 16.7918 -1.36824 21.4533 0.910406 26.5444C2.6552 30.4442 6.3466 32.0327 10.3245 32.6252C8.42343 29.0379 9.89478 24.6564 10.0575 24.1877C13.775 29.8127 20.7997 24.1877 17.2711 18.0744C21.8935 19.077 22.5836 27.0978 19.0354 32.1043C24.2763 30.4572 27.7659 26.3166 28.7229 22.6252C29.732 18.7645 28.9638 14.2983 27.0107 10.8478Z",
    fill: "#F43F5E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMostViewedRisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/most-viewed-risk.c7b4f915.svg";
export { ForwardRef as ReactComponent };